// extracted by mini-css-extract-plugin
export default {"admin_form":"login_admin_form__z87Za","admin_heading":"login_admin_heading__hV192","control":"login_control__YdF8+"};